import { LpInvestorUpdateType } from 'further-types/lp/investor-update';

export const lpInvestorUpdateTypeLabels = {
  [LpInvestorUpdateType.Bulletin]: 'Bulletin update',
  [LpInvestorUpdateType.PeriodEndReport]: 'Period-end report',
};
